import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, tap, throwError} from 'rxjs';
import {catchError} from "rxjs/operators";
import {Router} from "@angular/router";
import {AuthService} from "../_services/auth.service";
import {formatDisplayError} from "../_utils/error-message";
import {TimeoutNotifierService} from "../_services/timeout-notifier.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router, private injector: Injector) {
    }

    private get authService(): AuthService {
        return this.injector.get(AuthService);
    }

    private get timeoutNotifierService(): TimeoutNotifierService {
        return this.injector.get(TimeoutNotifierService);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(tap((httpEvent: HttpEvent<any>): void => {
            // Skip request
            if (httpEvent.type === 0) {
                return;
            }
            if (httpEvent instanceof HttpResponse) {
                if (httpEvent.headers.has('x-vmb-timeout-seconds')) {
                    const rawTimeout: string | number | undefined = httpEvent.headers.get('x-vmb-timeout-seconds')?.trim();
                    if (!rawTimeout || rawTimeout === 'None') {
                        return;
                    }
                    const timeoutSeconds: number = Number.parseInt(rawTimeout, 10);

                    if (!Number.isFinite(timeoutSeconds) || timeoutSeconds <= 0) {
                        return;
                    }
                    // convert seconds to milliseconds
                    // Send a notification to the user before the timeout so they can refresh
                    this.timeoutNotifierService.timeoutNotifier(timeoutSeconds * 1000);
                }
            }
        })).pipe(catchError(error => {
            let displayError: string = formatDisplayError(error);

            if (error.error?.code == 'token_expired' || error.status === 408) {
                displayError = "For security reasons you have been logged out due to inactivity please login again for access"
                if (this.authService.isLoggedIn()) {
                    if (window.location.href.includes('returnUrl')) {
                        let url: URL = new URL(window.location.href);
                        url.searchParams.delete('returnUrl'); // Removes the 'returnUrl' parameter
                        this.authService.logout(encodeURIComponent(url.pathname + url.search));
                    } else {
                        this.authService.logout(encodeURIComponent(window.location.pathname + window.location.search));
                    }
                }
                return throwError((): string => displayError)
            } else if (error.status === 401 || error.status === 403) {
                // If forbidden status then direct user to no access page.
                this.router.navigate(['/noAccess']);
                return throwError((): string => displayError)
            }

            return throwError((): string => displayError)
        }));
    }
}
